@if(mobileQuery.matches){
<div class="horizontal-sidebar py-2">
  <div class="container">
    <div>
      <div class="horizontal-navbar flex flex-row gap-4 items-center">
        @for(item of navItems; track trackNavItem(item, $index)){
        <app-horizontal-nav-item
          [item]="item"
          [openModuleId]="openModuleId()"
          (openModuleIdChange)="onOpenModule($event)"
          class="parentBox {{ item.ddType }}"
        >
        </app-horizontal-nav-item>
        }
        @if (showContextSwitch()) {
          <button
            type="button"
            class="horizontal-navbar__context menuLink"
            (click)="onContextSwitch()"
          >
            <span
              class="iconify routeIcon"
              [attr.data-icon]="contextSwitchIcon()"
              aria-hidden="true"
            ></span>
            {{ contextSwitchLabelKey() | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
}
